import React from 'react';
import { Modal, Spin, Tag } from 'antd';
import { CheckCircleFilled } from '@ant-design/icons';
import { RolesSectionSubtitle, TemplateList, TemplateCard } from '@/pages/inside/tenant/style';
import TemplateIllustration from './TemplateIllustration';
import { colors } from '@/utils/colorSystem';

export default function TemplateSelectModal({ 
    open, 
    onCancel, 
    templatesLoading, 
    currentTemplateId, 
    handleTemplateSelect, 
    templates 
}) {
    return (
        <Modal
            title="Change Project Template"
            open={open}
            onCancel={onCancel}
            footer={null}
            width={650}
            centered
            styles={{ body: { paddingTop: 20 } }}
        >
            <RolesSectionSubtitle style={{ marginBottom: 20 }}>
                Select a template to update project workflow rules and structure.
            </RolesSectionSubtitle>
            {templatesLoading ? (
                <div style={{ padding: 40, textAlign: 'center' }}><Spin size="large" /></div>
            ) : (
                <TemplateList>
                    <TemplateCard 
                        $selected={currentTemplateId === null || currentTemplateId === undefined} 
                        onClick={() => handleTemplateSelect(null)}
                    >
                        <div className="illustration-box"><TemplateIllustration type="standard" /></div>
                        <div className="content-box">
                            <div className="name">Standard Project</div>
                            <div className="description">Default structure with standard SDLC features.</div>
                        </div>
                        <div className="meta-box"><CheckCircleFilled className="check-icon" /></div>
                    </TemplateCard>
                    {templates.map(t => (
                        <TemplateCard 
                            key={t.id} 
                            $selected={currentTemplateId === t.id} 
                            onClick={() => handleTemplateSelect(t)}
                        >
                            <div className="illustration-box">
                                <TemplateIllustration 
                                    type={t.useSprints ? 'agile' : 'milestone'} 
                                    color={t.useSprints ? colors.primary[400] : colors.success[500]} 
                                />
                            </div>
                            <div className="content-box">
                                <div className="name">{t.name}</div>
                                <div className="description">{t.description || 'Professional workflow template.'}</div>
                            </div>
                            <div className="meta-box">
                                <div style={{ display: 'flex', gap: '4px' }}>
                                    {t.usePhases && <Tag bordered={false} color="blue">Phases</Tag>}
                                    {t.useSprints && <Tag bordered={false} color="purple">Sprints</Tag>}
                                </div>
                                <CheckCircleFilled className="check-icon" />
                            </div>
                        </TemplateCard>
                    ))}
                </TemplateList>
            )}
        </Modal>
    );
}
